import { Slugify } from '../../Admin/Functions/Slugify.js';

export const FilterOriginsByType = (datas, id) => {
    const collection = [];
    const map = new Map();
    if (!datas.errno) {
        for (const el of datas) {
            if (!map.has(el.oslug) && el.otid === id) {
                map.set(el.oslug, true);
                collection.push({
                    otslug: Slugify(el.otname),
                    otname: el.otname,
                    ocreated: el.ocreated,
                    oid: el.oid,
                    onumber: el.onumber,
                    oname: el.oname,
                    oroute: el.oroute,
                    oslug: el.oslug,
                });
            }
        }
    }
    return collection;
}
